import { render, staticRenderFns } from "./JiShiCommissionDetail.vue?vue&type=template&id=4fcaddbb&scoped=true&"
import script from "./JiShiCommissionDetail.vue?vue&type=script&lang=js&"
export * from "./JiShiCommissionDetail.vue?vue&type=script&lang=js&"
import style0 from "./JiShiCommissionDetail.vue?vue&type=style&index=0&id=4fcaddbb&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fcaddbb",
  null
  
)

export default component.exports